import { useState } from 'react';
import { sortRows, rowPassesColumnFilters, distinctColumnValues } from './15_SampleTracker';

/* Shared since 2026-10-08, when Cash Report Set up needed the same funnels GTM's two lists had.
   One copy, so a funnel behaves the same on every table that uses it. */
/* EXCEL'S SORT AND FILTER ON EVERY COLUMN — Max, 2026-10-08: "cái bảng bên GTM Programmes và GTM
   Approval thiếu sort và filter như excel nhé". Project Approval's own tools, IMPORTED from the
   tracker as Project Approval imports them (SortTh, sortRows, rowPassesColumnFilters,
   distinctColumnValues), so a funnel behaves the same on every table in the portal. One hook for
   both lists; a column filters and sorts on what its `get` returns, which is what the cell shows. */
export default function useColumnTools(rows, columns) {
  const [sort, setSort] = useState({ key: '', dir: 'asc' });
  const [colFilters, setColFilters] = useState({});
  const [openFilter, setOpenFilter] = useState(null);
  const getters = Object.fromEntries(columns.filter((c) => c.get).map((c) => [c.key, c.get]));
  const kept = Object.keys(colFilters).length
    ? rows.filter((r) => rowPassesColumnFilters(r, colFilters, getters)) : rows;
  const shown = sortRows(kept, sort, getters);
  const thProps = (key) => ({
    sortKey: key,
    sort,
    onSort: (k) => setSort((p) => (p.key === k ? { key: k, dir: p.dir === 'asc' ? 'desc' : 'asc' } : { key: k, dir: 'asc' })),
    filterValues: openFilter?.key === key ? distinctColumnValues(rows, key, colFilters, getters) : undefined,
    filterSelected: colFilters[key],
    filterOpen: openFilter?.key === key,
    filterAnchor: openFilter?.key === key ? openFilter.anchor : null,
    onOpenFilter: (k, anchor) => setOpenFilter((p) => (p && p.key === k ? null : { key: k, anchor })),
    onCloseFilter: () => setOpenFilter(null),
    onApplyFilter: (k, values, allValues) => {
      setColFilters((prev) => {
        const next = { ...prev };
        if (!values || !values.length || values.length === allValues.length) delete next[k];
        else next[k] = values;
        return next;
      });
      setOpenFilter(null);
    },
  });
  const clear = () => { setSort({ key: '', dir: 'asc' }); setColFilters({}); setOpenFilter(null); };
  return { shown, thProps, clear, active: !!sort.key || Object.keys(colFilters).length > 0 };
}

